var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInsurance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "insurance"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 21.9989C9.70362 21.3317 7.79619 19.9709 6.27771 17.9164C4.75924 15.8619 4 13.5468 4 10.9713V4.92407L12 2L20 4.92407V10.9713C20 13.5461 19.2408 15.8607 17.7223 17.9152C16.2038 19.9697 14.2964 21.3302 12 21.9989Z",
    fill: "#E3E4E9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 839",
    d: "M8 11.6667C8.38095 12 11.0476 14 11.0476 14L16 9",
    stroke: "#202E5F",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsurance);
export default __webpack_public_path__ + "static/media/insurance.2d5ec95ca3c0f807365ebb844ac49fe1.svg";
export { ForwardRef as ReactComponent };